export default `---
slug: malaysia
country: Malaysia
countryCode: MYS
continent: Asia
year: 2025
title: "Business Class and the Rainforest"
description: "Two weeks in Kuala Lumpur for work, a 12-hour business class flight, scorpions that glow under UV light, and getting drunk with my boss's boss's boss."
thumbnail: /images/travels/MYS/petronas.jpg
relatedLinks: []
---

In December 2024, my manager told me to book a ticket to Kuala Lumpur. There was a project, there was an office there, and I was going for two weeks in January.

<b>Business class.</b> Amsterdam to KL, twelve hours, company policy.

I want to be clear about what twelve hours in a business class flat bed does to your mental state: you arrive feeling like a different, slightly better version of yourself. I had barely landed and I was already having a great time.

## Two Weeks at Full Speed

The work was intense — ten-plus hours in the office most days — but it was the good kind of intense. A new project, new colleagues, and a genuine opportunity to expand my network in a way that doesn't happen when you're sitting in the Amsterdam office. My colleague Shashank and I fell into an easy rhythm: work hard all day, then go eat somewhere new every evening.

And the food. <i>The food.</i>

The hotel was surrounded by three malls within walking distance, which means it was also surrounded by an effectively infinite variety of restaurants. Malaysian food, Indian food, Chinese food, Japanese food, food I couldn't name but ordered anyway. Every lunch, every dinner, something different. I cannot stress this enough. If you ever find yourself in Kuala Lumpur for two weeks, please dedicate serious time to eating.

## Into the Rainforest

Between the two work weeks, I had a free weekend and my colleague Zeke said simply: "Taman Negara." The national park. The oldest rainforest on the planet — older than the Amazon, they say.

I paid around 250 euros for an all-organised trip, woke up at six on Saturday morning, and got on a very long bus. A few hours later we transferred to a boat and travelled upstream for two hours — just sitting there in the warm air, watching the jungle slide past on both sides, water buffalo visible occasionally at the banks. It was one of those rare moments of total stillness in an otherwise constantly-moving trip.

The forest stay was run by a guide who was around sixty years old, had grown up in that forest, and whose father had grown up in that forest. He knew every tree, every bird call, every plant that would make you ill and every plant that would make you better. Worth their weight in gold, this type of person.

## Scorpions That Glow in the Dark

The Saturday night was a guided walk through the forest after dark.

I was expecting insects and sounds. I was not expecting scorpions. Specifically, I was not expecting to learn that scorpions — completely invisible under a normal torch — <b>fluoresce bright blue-green under UV light.</b> The guide swept a UV torch across a log and suddenly a scorpion that had been invisible was absolutely glowing. Bizarre and spectacular in equal measure.

![Scorpion glowing under UV light, Taman Negara](/images/travels/MYS/scorpion.jpg)

The Sunday was a morning walk with just me and a Swiss guy and our guide, followed by a boat trip to see a traditional local village — blowpipes, fire-making, the whole thing. The guide explained the way of life there: one hut, whole family, no running water, no bills, no rent. And, as he put it: no stress. <i>Everything they need, the forest provides.</i>

I thought about that for a while on the bus back.

## The Celebration

The second week ended with a Wednesday night out — my boss's boss's boss decided it was time to celebrate the project wrapping up. We went out. We got drunk. It was one of those evenings that could only happen on a work trip, where hierarchy briefly dissolves and everyone's just people at a table.

My last morning in KL I refused to waste. I woke up early, walked to the Malaysia History Museum for a free English-language guided tour, then went to the bird zoo — one of the largest in the world, with birds that wander freely around visitors — then made one final pass by the Petronas Towers, which I had first seen on the Sunday I arrived.

![The Petronas Towers, Kuala Lumpur](/images/travels/MYS/petronas.jpg)

<b>Two weeks. Business class in both directions. Rainforest, scorpions, and food I still think about.</b>

KL absolutely delivered.
`;
